<template>
    <div class="item">
        <div class="title">气象土壤气息</div>
        <div class="value">
          <div class="option" v-for="(item,index) in list" :key="index">
            <div class="left">
              <img src="../../assets/manure/soli.png" alt="">
            </div>
            <div class="right">
              <p>{{ item.name }}</p>
              <p v-if="item.status == '1'" class="red" @mouseover="over" @mouseout="out">{{ item.value }}{{ item.unit }}</p>
              <p v-else >{{ item.value }}{{ item.unit }}</p>
            </div>
          </div>
        </div>
        <!-- 阙值 -->
        <div class="threshold" v-if="show">
          <p>系统阙值：339PM</p>
        </div>
    </div>
  </template>
  
  <script>
import { getQX_wfQxInfo } from '../../api/api'

  export default {
    data () {
      return {
        // 列表
        list:[
          {name:"空气温度", value:"", unit:"℃", status:"1"},
          {name:"空气湿度", value:"", unit:"%RH", status:"0"},
          {name:"气压", value:"", unit:"hpa", status:"0"},
          {name:"风向", value:"", unit:"°", status:"0"},
          {name:"风速", value:"", unit:"m/s", status:"1"},
          {name:"降雨量累计", value:"", unit:"mm", status:"0"}, 
          {name:"光照度", value:"", unit:"LUX", status:"0"}, 
          {name:"总辐射", value:"", unit:"w/㎡", status:"0"}, 
          {name:"光合有效辐射", value:"", unit:"w/㎡", status:"0"}, 
          {name:"日照时数", value:"", unit:"h", status:"0"}, 
          {name:"二氧化碳", value:"", unit:"PPM", status:"1"}, 
          {name:"土壤温度", value:"", unit:"℃", status:"0"}, 
          {name:"土壤含水率", value:"", unit:"%RH", status:"0"}, 
        ],
        // 控制阙值显示
        show:false,
      }
    },
    created () { 
      this.projectId = JSON.parse(localStorage.getItem("projectId"))
      if(this.projectId ){
          this.getData(this.projectId)
      }
    },
    beforeDestroy() {
      // 移除绑定的listenResizeFn事件监听
      window.removeEventListener("setItemEvent",this.getData);
    },
    mounted () { 
      
      let _this = this
      window.addEventListener('setItemEvent', function(e) {
          const newdata = JSON.parse(e.newValue)
          _this.getData(newdata)
      })
    },
    methods: {
      // 获取数据
      async getData(projectId){
        let res = await getQX_wfQxInfo({
          projectId
        })
        console.log(res,"气象土壤信息");
        if(res.code == 200 && res.data){
          let data = res.data
          this.list.forEach(item => {
            if(item.name == "空气温度"){
              item.value = data.at
            }
            if(item.name == "空气湿度"){
              item.value = data.ah
            }
            if(item.name == "气压"){  //取的是模拟气压  还有一个数字气压 dap
              item.value = data.sap
            }
            if(item.name == "风向"){
              item.value = data.wd
            }
            if(item.name == "风速"){
              item.value = data.ws
            }
            if(item.name == "降雨量累计"){
              item.value = data.rfa
            }
            if(item.name == "光照度"){
              item.value = data.ioi
            }
            if(item.name == "总辐射"){  //取得是简易总辐射 还有一个TBQ总辐射 tr
              item.value = data.str
            }
            if(item.name == "光合有效辐射"){
              item.value = data.par
            }
            if(item.name == "日照时数"){
              item.value = data.sh
            }
            if(item.name == "二氧化碳"){
              item.value = data.co2
            }
            if(item.name == "土壤温度"){
              item.value = data.st
            }
            if(item.name == "土壤含水率"){
              item.value = data.sm;
            }
          })
        }else{
          // this.list = []
        }
      },

      // 鼠标移入
      over(){
        this.show = true
      },
      // 鼠标移出
      out(){
        this.show = false
      }
    }
    
  }
  </script>

  <style lang="scss" scoped>
  .item{
    position: relative;
    padding: 15px 6px 6px 15px;
    background-color: rgba(0, 0, 0, 0.5);
    font-family: SourceHanSansSC-regular;
    width: 500px;
    height: 350px;
    overflow-y: auto;
    .title{
        font-size: 20px;
        font-weight: bold;
        line-height: 29px;
        margin-bottom: 12px;
    }
    .value{
        display: flex;
        flex-wrap: wrap;;
        .option{
          width: 32%;
          margin-bottom: 18px;
          display: flex;
          align-items: center;
          .left{
            margin-right: 8px;
            img{
              width: 49px;
              height: 49px;
            }
          }
          .right{
            // text-align: center;
            p{
              font-size: 16px;
              line-height: 23px;
            }
            .red{
              cursor: pointer;
              text-align: center;
              border-radius: 12px;
              background: red;
              width: 70px;
              height: 25px;
              line-height: 25px;
            }
          }
        }
        
    }

    .threshold{
      
      position: absolute;
      bottom: 40px;
      right: 40px;
      padding: 6px 10px;
      border-radius: 13px;
      color: #000;
      background-color: rgba(173, 168, 168, 0.8);
      font-size: 14px;
      text-align: center;
    }
  }
  
  
  </style>
  